import {resolveBackground} from '#core/utils/color-utils.js';
import {isMobile} from '#core/utils/context-utils.js';

import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';

export function promotionsFactory(PALETTE) {
    return {
        BannerSkeletons: {
            bannerSkeleton: generateSkeletonPart(PALETTE.SKELETON),
        },
        BannerPromotionsView: {
            innerContainer: {
                style: {
                    ...resolveBackground(PALETTE.BANNER_CONTAINER_BG),
                },
            },
            swiper: {
                slide: {
                    style: {
                        flexBasis: '100%',
                    },
                },
            },
        },
        BannerPromotion: {
            bannerMarket: {
                style: {
                    height: '100%',
                    boxSizing: 'border-box',
                    justifyContent: 'space-between',
                    padding: '4px',
                    _mobile_padding: '2px',
                    gap: '4px',
                    _mobile_gap: '2px',
                },
                eventName: {
                    margin: 0,
                    text: {
                        ...(isMobile()
                            ? PALETTE.BANNER_MARKET_MOBILE_EVENT_NAME_TEXT
                            : PALETTE.BANNER_MARKET_EVENT_NAME_TEXT),
                    },
                },
                sportLeague: {
                    padding: 0,
                    boxSizing: 'border-box',
                    textStyles: {
                        ...(isMobile()
                            ? PALETTE.BANNER_MARKET_MOBILE_SPORT_LEAGUE_TEXT
                            : PALETTE.BANNER_MARKET_SPORT_LEAGUE_TEXT),
                    },
                },
                startTime: {
                    top: 4,
                    _mobile_top: 2,
                    right: 4,
                    _mobile_right: 2,
                    textStyles: {
                        ...(isMobile()
                            ? PALETTE.BANNER_MARKET_MOBILE_START_TIME_TEXT
                            : PALETTE.BANNER_MARKET_START_TIME_TEXT),
                    },
                },
                participants: {
                    width: '70%',
                    _mobile_width: '95%',
                    minWidth: '300px',
                    _mobile_minWidth: 'initial',
                    gap: '4px',
                },
                market: {
                    container: {
                        itemSpacing: '4px',
                        style: {
                            _mobile_width: '95%',
                            _mobile_minWidth: 'initial',
                        },
                    },
                },
            },
            marketOverlay: {
                style: {
                    ...resolveBackground(PALETTE.BANNER_MARKET_CONTAINER_BG),
                    display: 'block',
                    _mobile_height: '100%',
                    maxHeight: '100px',
                },
            },
        },
    };
}
